<div class="flex flex-col items-center gap-1.5" [class]="timerState()">
  @if (showLabel()) {
    <div class="timer-label font-dm-sans text-[10px] font-semibold text-lilate-dark uppercase tracking-wider" translate>exam-circular-timer.available-time</div>
  }
  <div class="relative w-[110px] h-[110px]">
    <!-- SVG anneau -->
    <svg class="timer-svg w-[110px] h-[110px]" viewBox="0 0 110 110">
      <circle class="timer-bg" cx="55" cy="55" r="50" />
      <circle
        class="timer-progress"
        cx="55" cy="55" r="50"
        [attr.stroke-dasharray]="circumference"
        [attr.stroke-dashoffset]="strokeDashoffset()" />
    </svg>
    <!-- Temps au centre -->
    <div class="absolute inset-0 flex items-center justify-center">
      <span class="timer-time font-dm-serif text-[26px] text-lilate-ink leading-none tracking-tight">{{ timeDisplay() }}</span>
    </div>
  </div>
</div>
